<div class="chat-wrapper" (click)="letsChat()">
    <img src="https://images.5paisa.com/forum/icon-chat.png" />      
      <span>Let's Chat</span>
</div>